module.exports = __webpack_public_path__ + "img/campaign.718378cf.svg";